module.exports = __webpack_public_path__ + "img/twitter.38db32b4.png";